import i18n from '@app/i18n';

export const transformBoolean = (text: string): string => {
  switch (text) {
    case 'false':
      return i18n.t('common.no');
    case 'true':
      return i18n.t('common.yes');

    default:
      return '';
  }
};
